import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=4bce7013&scoped=true&"
import script from "./Purchases.vue?vue&type=script&lang=js&"
export * from "./Purchases.vue?vue&type=script&lang=js&"
import style0 from "./Purchases.vue?vue&type=style&index=0&id=4bce7013&lang=scss&scoped=true&"
import style1 from "./Purchases.vue?vue&type=style&index=1&id=4bce7013&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce7013",
  null
  
)

export default component.exports